import { IWPImage, IWPLink } from "@/src/types";
import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { AnimationOnScroll } from "react-animation-on-scroll";

import S from "./ImageBlock.styled";
import { MainInner } from "@/styles/global";
import { Link } from "gatsby";

export interface Props {
  animation: string;
  images: {
    mediatype: "image" | "video";
    image: IWPImage;
    vimeoId: string;
    text: string;
    link: IWPLink;
  }[];
}

const ImageBlock: React.FC<Props> = ({ images, animation }) => {
  const renderImage = images?.map(
    ({ mediatype, vimeoId, image, text, link }, key) => {
      const imageData = image?.localFile?.childImageSharp?.gatsbyImageData
        ? getImage(image.localFile.childImageSharp.gatsbyImageData)
        : null;

      return (
        <>
          {imageData && link && mediatype === "image" && (
            <S.ImageWrapper key={key}>
              <S.ImageLink to={link.url}>
                <S.Image image={imageData} alt={image.altText || ""} />
              </S.ImageLink>
              {text && <S.Text>{text}</S.Text>}
              <S.ImageLink to={link.url}>{text}</S.ImageLink>
            </S.ImageWrapper>
          )}
          {mediatype === "video" && vimeoId && link && (
            <S.ImageWrapper key={key}>
              <S.ImageLink to={link.url}>
                {imageData && (
                  <S.Image image={imageData} alt={image.altText || ""} />
                )}
                <iframe
                  src={`https://player.vimeo.com/video/${vimeoId}?h=bc7bf21e48&autoplay=1&loop=1&title=0&byline=0&portrait=0&muted=1&autopause=0&controls=0`}
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </S.ImageLink>
            </S.ImageWrapper>
          )}
          {imageData && mediatype === "image" && !link && (
            <S.ImageWrapper key={key}>
              <S.Image image={imageData} alt={image.altText || ""} />
              {text && <S.Text>{text}</S.Text>}
            </S.ImageWrapper>
          )}
          {mediatype === "video" && vimeoId && !link && (
            <S.ImageWrapper key={key}>
              {imageData && (
                <S.Image image={imageData} alt={image.altText || ""} />
              )}
              <iframe
                src={`https://player.vimeo.com/video/${vimeoId}?h=bc7bf21e48&autoplay=1&loop=1&title=0&byline=0&portrait=0&muted=1&autopause=0&controls=0`}
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              ></iframe>
            </S.ImageWrapper>
          )}
        </>
      );
    }
  );

  return (
    <AnimationOnScroll
      animateIn={`animate__${animation}`}
      animateOnce={true}
      initiallyVisible={animation == "none" ? true : false}
      duration={animation === "none" ? 0 : 1}
      delay={animation === "none" ? 0 : 100}
    >
      <MainInner>
        <S.Container>{renderImage}</S.Container>
      </MainInner>
    </AnimationOnScroll>
  );
};

export default ImageBlock;
